import { cloneDeep, isArray, mergeWith } from 'lodash'
import { StateCreator } from 'zustand'

import { EClientPath } from '~/models/api'
import EStoreStateKeys from '~/models/store'

type TUserDefinition = {
  id: string
  partnerId: string
  organizationId: string
  signInRedirectPath: EClientPath | null
  referredBy: string
  impersonatorsOrgId?: string
  impersonatorsUserId?: string
  lastSelectedAgentId?: string
  isValidated: boolean
}

type TUser = {
  [EStoreStateKeys.user]: TUserDefinition
}

export type TUserState = TUser & {
  setUser(user: Partial<TUserDefinition>): void
}

export const initialUserState: TUserDefinition = {
  id: '',
  organizationId: '',
  partnerId: '',
  signInRedirectPath: null,
  referredBy: '',
  impersonatorsOrgId: '',
  impersonatorsUserId: '',
  lastSelectedAgentId: '',
  isValidated: false, // with this field we validate that the user signed in has the correct email & cognitoId combination. This is to prevent users to access the application with other means than with what they registered. Example: if a user registered with Google SSO, they should not be able to access the application with email and password, even if the email is the same, because the cognitoId will be different.
}

const createUserSlice: StateCreator<
  TUserState,
  [['zustand/devtools', unknown]],
  []
> = (set) => ({
  user: cloneDeep(initialUserState),
  setUser: (user) =>
    set(
      (state) => ({
        user: mergeWith(cloneDeep(state.user), user, (objValue, srcValue) => {
          if (isArray(objValue)) {
            return srcValue
          }
          // eslint-disable-next-line consistent-return
          return undefined
        }),
      }),
      undefined,
      {
        type: 'setUser',
        user,
      },
    ),
})

export default createUserSlice
